  "use client";
import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
 
import { Link } from 'react-router-dom';
import IconButton from '../../../../components/icon-button';
import { deleteUser } from '../actions';

export function CreateUser() {
  return (
    <Link
      to="/dashboard/invoices/create"
      className="flex h-10 items-center rounded-lg bg-purple-600 px-4 text-sm font-medium text-white transition-colors hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    >
      <span className="hidden md:block">Create User</span>{' '}
      <PlusIcon className="h-5 md:ml-4" />
    </Link>
  );
}

export function UpdateUser({ id }: { id: string }) {
  return (
    <Link
      to={`/admin/users/edit/${id}`}      
    >      
      <IconButton label='Edit' icon={PencilIcon}></IconButton>   
    </Link>
  );
}

export function DeleteUser({ id }: { id: string }) {

  const deleteUserWithId = deleteUser.bind(null,id);
   function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this user?")) {
      e.preventDefault();
    }
  }

  return (
    <form action={deleteUserWithId} onSubmit={handleSubmit}>
      <IconButton label='Delete' icon={TrashIcon}></IconButton>   
    </form>
  );
}
